import services from './services';
import {
    cloneDeep,
    util,
} from 'utils';
import $http from '$http';

export default {
    mixins: [services],
    props: {},
    data() {
        return {
            diolagVisible: false,
            loading: false,
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            pageSizes: [10, 20, 50],
            DepartmentList: [],
            form: this.submitData()
        }
    },
    methods: {
        submitData() {
            return cloneDeep({
                "Id": 0,
                "Name": ""
            });
        },
        show(opts) {
            this.pageIndex = 1;
            this.diolagVisible = true
            this.GetBuessionPartList()
        },
        addFn() {
            if (this.form.Name == "") {
                this.$notify({
                    title: '警告',
                    message: '请输入业务部门名称',
                    type: 'warning'
                });
                return
            }
            this.ModifyBuessionPart()
        },
        // del
        handleDel(index, row) {
            this.$confirm('确认删除吗？', '提示', {}).then(() => {
                let params = {
                    "Id": row.Id,
                    "Name": row.Name
                }
                this.DelList(params)
            })
        },
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.GetBuessionPartList()
        },
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.GetBuessionPartList()
        }

    },
    created() {}
}


// WEBPACK FOOTER //
// ./src/pages/Agent/AddEmployee/components/addDepartment/vm.js